<template>
  <div class="d-flex flex-row gap-4 align-items-center">
    <input style="width: 2rem;height: 2rem;" type="radio" :value="value" :name="name" :id="id"
      autocomplete="off" :checked="modelValue==value" @input="check" @click="uncheckable ? uncheck() : pass">
    <label class="m-0" :for="id">{{ text }}</label>
  </div>
</template>

<script>
export default {
  name: "argon-radio",
  props: {
    modelValue: [String, Number],
    name: String,
    id: String,
    text: String,
    value: [String, Number],
    uncheckable: Boolean,
  },
  methods: {
    uncheck() {
      this.$emit('update:modelValue', "");
    },
    check() {
      this.$emit('update:modelValue', this.value)
    },
  },
};
</script>
